import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ACCREDIBLE_WIZARD_STEP_STATE, AccredibleWizardStep } from './models/wizard-step.model';

@Component({
  standalone: true,
  selector: 'accredible-wizard',
  imports: [CommonModule, AccredibleIconComponentModule],
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleWizardComponent {
  @Input()
  steps: AccredibleWizardStep[];

  stepState = ACCREDIBLE_WIZARD_STEP_STATE;

  @Input()
  set currentStep(currentStep: number) {
    if (!this.steps) {
      return;
    }
    // if index is out of bounds we assume the first step as current
    if (currentStep < 0 || currentStep > this.steps.length + 1) {
      currentStep = 0;
    }

    this.steps.forEach((step, i) => {
      if (currentStep > i) {
        step.state = ACCREDIBLE_WIZARD_STEP_STATE.VALIDATED;
        return;
      }

      if (currentStep === i) {
        step.state = ACCREDIBLE_WIZARD_STEP_STATE.CURRENT;
        return;
      }

      step.state = ACCREDIBLE_WIZARD_STEP_STATE.PENDING;
    });
  }
}
